module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Kettle-d854b8a47e296dfe63928eadf57332a4.svg";